// eslint-disable import/extensions
import React from 'react';
import {
	Page, Text, Font, Document, StyleSheet, Path, Svg, View,
} from '@react-pdf/renderer';
// eslint-disable-next-line import/extensions
import Inter400 from 'wb-reddit/app/common/components/twoFactor/assets/Inter-Regular.ttf';
// eslint-disable-next-line import/extensions
import Inter500 from 'wb-reddit/app/common/components/twoFactor/assets/Inter-Medium.ttf';
// eslint-disable-next-line import/extensions
import Inter600 from 'wb-reddit/app/common/components/twoFactor/assets/Inter-SemiBold.ttf';
import { VARIABLES } from 'wb-reddit/styles/variables';

function WbLogoSvg() {
	return (<Svg
		width="105"
		height="48"
		viewBox="0 0 105 48"
		fill="none"
	>
		<Path d="M68.7261 43.8398C68.7261 43.0013 68.1469 42.4428 67.391 42.4428C66.6287 42.4428 66.0559 43.0013 66.0559 43.8398C66.0559 44.6775 66.6287 45.236 67.391 45.236C68.1469 45.236 68.7261 44.6775 68.7261 43.8398ZM69.2101 43.8398C69.2101 44.9232 68.4469 45.6657 67.4254 45.6657C66.8326 45.6657 66.335 45.4073 66.0423 44.9232V45.6321H65.5791V40.5762H66.0631V42.7293C66.3631 42.266 66.8526 42.0203 67.4254 42.0203C68.4469 42.0203 69.2101 42.7565 69.2101 43.8398Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M73.1615 42.0664L71.3704 46.0798C71.0704 46.7815 70.6888 47.0063 70.1785 47.0063C69.8441 47.0063 69.5241 46.8975 69.3057 46.6791L69.5314 46.3182C69.7081 46.495 69.9256 46.5902 70.1849 46.5902C70.5048 46.5902 70.7233 46.4406 70.9272 45.991L71.084 45.6438L69.4833 42.0664H69.9873L71.336 45.1125L72.6847 42.0664H73.1615Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M84.9616 38.0605H86.4453V45.6323H84.9616V38.0605Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M95.7021 41.2521C95.3359 41.2521 95.0685 41.3645 94.8999 41.5893C94.7313 41.8151 94.6434 42.1877 94.6371 42.7062V42.8667C94.6371 43.4514 94.7241 43.8693 94.8972 44.1223C95.0703 44.3752 95.3459 44.5021 95.722 44.5021C96.3864 44.5021 96.7191 43.9537 96.7191 42.8576C96.7191 42.3227 96.6375 41.9211 96.4734 41.6537C96.3103 41.3853 96.052 41.2521 95.7021 41.2521ZM96.1399 45.7043C95.5009 45.7043 95.0005 45.4722 94.6371 45.008H94.5591C94.6108 45.4622 94.6371 45.7251 94.6371 45.7967V48.0006H93.1533V40.1669H94.3053L94.5691 40.8722H94.6371C94.9842 40.3337 95.4982 40.0645 96.1789 40.0645C96.8215 40.0645 97.3236 40.3129 97.6871 40.8088C98.0506 41.3056 98.2318 41.9946 98.2318 42.8766C98.2318 43.4578 98.1466 43.9618 97.9771 44.3906C97.8067 44.8185 97.5638 45.144 97.2493 45.3679C96.9348 45.5918 96.565 45.7043 96.1399 45.7043Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M104.135 45.6314H102.651V42.4538C102.651 41.6687 102.359 41.2762 101.775 41.2762C101.36 41.2762 101.06 41.4176 100.875 41.6995C100.69 41.9815 100.598 42.4393 100.598 43.0721V45.6314H99.1143V38.0605H100.598V39.6026C100.598 39.7223 100.587 40.0051 100.564 40.4494L100.53 40.8872H100.608C100.939 40.3551 101.464 40.0895 102.184 40.0895C102.823 40.0895 103.308 40.2608 103.639 40.6044C103.97 40.948 104.135 41.4412 104.135 42.0839V45.6314Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M79.2666 42.505C78.9901 42.4161 78.681 42.4524 78.3982 42.4515C78.0728 42.4497 77.7194 42.4125 77.3958 42.4787C77.0323 42.5548 76.7568 42.9202 76.6244 43.3073C76.4604 43.786 76.4495 44.3172 76.2854 44.7959C76.2202 44.9881 76.1241 45.1667 76.0008 45.3154C75.9338 45.396 75.8576 45.4686 75.7733 45.5248C75.6519 45.6064 75.3963 45.6354 75.7833 45.629C76.1694 45.6327 76.5565 45.6372 76.9435 45.6408L76.8474 45.6254C76.5972 45.5701 76.3108 45.6064 76.057 45.6064C75.8712 45.6073 75.6845 45.6073 75.4987 45.6118C75.4298 45.6136 75.3328 45.6399 75.2676 45.6254C75.5649 45.6916 75.8812 45.6635 76.1821 45.6635C76.4858 45.6635 76.8239 45.7043 77.1239 45.629C77.4746 45.542 77.7366 45.1721 77.8653 44.7959C78.0239 44.3308 78.0393 43.8186 78.1898 43.3499C78.3049 42.9927 78.6067 42.495 78.9747 42.4787L77.5308 42.4741C77.5843 42.4741 77.6369 42.485 77.6867 42.505C77.9206 42.5802 78.236 42.524 78.4771 42.524C78.6629 42.524 78.8487 42.5231 79.0354 42.5186C79.0998 42.5168 79.2077 42.4859 79.2666 42.505Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M81.8737 45.6157H83.9349L80.1117 35.3125H79.9612L78.9941 37.9334L81.8737 45.6157Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M89.0359 41.4198C89.2136 41.2203 89.461 41.1206 89.7746 41.1206C90.0891 41.1206 90.3393 41.2203 90.5242 41.4198C90.7091 41.6192 90.8043 41.9021 90.8115 42.2683H88.7287C88.7549 41.9021 88.8565 41.6192 89.0359 41.4198ZM91.5276 44.3263C91.3409 44.3979 91.1587 44.4559 90.9819 44.4976C90.6892 44.5656 90.3792 44.6 90.052 44.6C89.6305 44.6 89.3033 44.4813 89.0694 44.2447C88.8365 44.0081 88.7114 43.6781 88.6951 43.2565H92.2028V42.5367C92.2028 41.7643 91.988 41.1596 91.5602 40.7217C91.1324 40.2838 90.5342 40.0645 89.7656 40.0645C88.9607 40.0645 88.3307 40.3138 87.8757 40.8115C87.4198 41.3092 87.1914 42.0145 87.1914 42.9256C87.1914 43.8113 87.438 44.4958 87.931 44.979C88.4241 45.4622 89.1084 45.7043 89.984 45.7043C90.4091 45.7043 90.7689 45.6725 91.0644 45.6091C91.359 45.5465 91.6364 45.4495 91.8965 45.3199V45.3181L91.5276 44.3263Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M17.5523 4.72235L18.6109 0H23.4257L19.0025 16.4036H13.8433L12.83 11.5416C12.3532 9.22349 11.9852 7.22631 11.7242 5.55186C11.4323 7.36501 11.0562 9.36129 10.5957 11.5416L9.58147 16.4036H4.4223L0 0H4.81385L5.87343 4.72235C6.54869 7.71767 7.00913 9.90614 7.25567 11.2887C7.60826 9.13827 8.01523 6.9498 8.47658 4.72235L9.4437 0H13.9811L14.9491 4.72235C15.4096 6.9498 15.8165 9.13827 16.17 11.2887C16.4302 9.90614 16.8915 7.71767 17.5523 4.72235Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M27.9699 3.31716H23.9854V0H27.9699V3.31716ZM28.085 16.4036H23.8467V4.51565H28.085V16.4036Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M34.3069 16.7736C32.311 16.7736 30.8399 16.4509 29.8964 15.8063C28.9519 15.1608 28.4253 14.101 28.3184 12.627H32.418C32.4796 13.1646 32.66 13.5408 32.96 13.7556C33.2591 13.9705 33.7386 14.0784 34.3993 14.0784C35.5196 14.0784 36.0807 13.7783 36.0807 13.1791C36.0807 12.8881 35.9502 12.6614 35.6891 12.5C35.4281 12.3387 34.9595 12.2045 34.2842 12.0966L32.5793 11.8428C29.8302 11.4439 28.4561 10.2073 28.4561 8.13397C28.4561 6.87474 28.9438 5.91014 29.9191 5.242C30.8943 4.57385 32.311 4.24023 34.1691 4.24023C37.8545 4.24023 39.7815 5.61551 39.951 8.36424H36.058C36.0272 7.41234 35.3973 6.93639 34.1691 6.93639C33.125 6.93639 32.6029 7.23556 32.6029 7.8348C32.6029 8.11131 32.7135 8.31801 32.9364 8.45671C33.1594 8.59451 33.5392 8.70239 34.0767 8.77945L36.1043 9.05505C37.5318 9.25541 38.5869 9.66246 39.2712 10.2762C39.9546 10.8909 40.2963 11.743 40.2963 12.8337C40.2963 14.0938 39.7742 15.0647 38.7301 15.7483C37.6859 16.4319 36.2112 16.7736 34.3069 16.7736Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M47.2985 7.23556C46.0386 7.23556 45.2791 7.88013 45.018 9.17019H49.6479C49.3714 7.88013 48.5883 7.23556 47.2985 7.23556ZM53.7248 10.9217V11.6814H45.018C45.2945 13.0177 46.0848 13.6858 47.391 13.6858C48.3735 13.6858 49.0723 13.3404 49.4865 12.6496H53.4484C53.1257 13.9243 52.4124 14.9151 51.3066 15.6214C50.1854 16.3276 48.8802 16.6812 47.391 16.6812C45.4866 16.6812 43.943 16.1127 42.7611 14.9759C41.5783 13.84 40.9873 12.3341 40.9873 10.4602C40.9873 8.57094 41.5701 7.06603 42.7375 5.9446C43.9041 4.80866 45.4404 4.24023 47.3447 4.24023C49.2482 4.24023 50.7917 4.83132 51.9746 6.0144C53.1411 7.19658 53.7248 8.83294 53.7248 10.9217Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M54.1743 11.832H58.873V16.3939H54.1743V11.832Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M65.8831 7.5563C64.5008 7.5563 63.8092 8.52452 63.8092 10.4592C63.8092 12.3947 64.5008 13.362 65.8831 13.362C67.2644 13.362 67.956 12.3639 67.956 10.3676C67.956 8.4937 67.2644 7.5563 65.8831 7.5563ZM67.1493 4.23914C68.7155 4.23914 69.9519 4.80031 70.8583 5.92084C71.7638 7.04227 72.2169 8.55534 72.2169 10.4592C72.2169 12.3639 71.7638 13.8769 70.8583 14.9984C69.9519 16.1198 68.7155 16.6801 67.1493 16.6801C65.6293 16.6801 64.4927 16.0962 63.7404 14.9286V16.4036H59.6172V0H63.8555V5.8057C64.6232 4.76133 65.7208 4.23914 67.1493 4.23914Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M73.2646 0H77.5029V16.4036H73.2646V0Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M86.7111 11.1085V4.51953H90.9485V16.4074H86.8027V14.8409C85.851 16.0702 84.6147 16.684 83.0937 16.684C81.8656 16.684 80.8749 16.2959 80.1226 15.5208C79.3703 14.7448 78.9941 13.6424 78.9941 12.2145V4.51953H83.2324V11.3161C83.2324 12.4983 83.7699 13.0903 84.8449 13.0903C85.3824 13.0903 85.8274 12.9171 86.1809 12.5717C86.5335 12.2254 86.7111 11.7386 86.7111 11.1085Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M97.9733 7.23556C96.7143 7.23556 95.9539 7.88013 95.6928 9.17019H100.323C100.046 7.88013 99.2631 7.23556 97.9733 7.23556ZM104.4 10.9217V11.6814H95.6928C95.9693 13.0177 96.7606 13.6858 98.0658 13.6858C99.0483 13.6858 99.7471 13.3404 100.161 12.6496H104.123C103.801 13.9243 103.087 14.9151 101.981 15.6214C100.86 16.3276 99.555 16.6812 98.0658 16.6812C96.1614 16.6812 94.6179 16.1127 93.4359 14.9759C92.2531 13.84 91.6621 12.3341 91.6621 10.4602C91.6621 8.57094 92.2458 7.06603 93.4124 5.9446C94.5798 4.80866 96.1152 4.24023 98.0195 4.24023C99.9239 4.24023 101.467 4.83132 102.649 6.0144C103.816 7.19658 104.4 8.83294 104.4 10.9217Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M13.1312 19.9142L14.1446 24.8296H19.3046L21.2416 17.5625H16.8864C16.716 18.3911 16.5764 19.0946 16.4713 19.6585C16.358 18.9641 16.2383 18.2642 16.1141 17.5625H12.6689C12.8103 18.3068 12.9635 19.0892 13.1312 19.9142Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M4.17419 24.8296H9.33428L10.3476 19.9142C10.5171 19.1028 10.6712 18.324 10.818 17.5625H7.36468C7.24051 18.2642 7.11996 18.9641 7.00757 19.6585C6.90786 19.0946 6.77191 18.3911 6.60332 17.5625H2.23633L4.17419 24.8296Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M23.3349 17.5625H27.5732V24.8296H23.3349V17.5625Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M32.5793 20.2179L34.2842 20.4744C34.9595 20.5832 35.4281 20.7192 35.6891 20.8815C35.9502 21.0447 36.0807 21.274 36.0807 21.5687C36.0807 22.1742 35.5196 22.477 34.3993 22.477C33.7395 22.477 33.2591 22.3692 32.96 22.1516C32.66 21.934 32.4796 21.5532 32.4189 21.0093H28.3184C28.4262 22.5006 28.9519 23.5722 29.8964 24.224C30.8408 24.8767 32.311 25.2031 34.3069 25.2031C36.2112 25.2031 37.6859 24.8568 38.7301 24.166C39.7733 23.4752 40.2963 22.4934 40.2963 21.2196C40.2963 20.1172 39.9546 19.2551 39.2712 18.6341C38.7364 18.1482 37.9696 17.7928 36.9789 17.5625H28.603C29.0235 19.0049 30.3487 19.8906 32.5793 20.2179Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M40.9873 18.8208C40.9873 20.7147 41.5783 22.2368 42.7611 23.3854C43.943 24.535 45.4866 25.1097 47.3901 25.1097C48.8802 25.1097 50.1854 24.7525 51.3066 24.0373C52.4124 23.3238 53.1257 22.322 53.4484 21.0329H49.4865C49.0723 21.7318 48.3726 22.0809 47.3901 22.0809C46.0848 22.0809 45.2945 21.4055 45.018 20.0547H53.7248V19.2859C53.7248 18.6712 53.6695 18.1001 53.5707 17.5625H41.0834C41.0217 17.9623 40.9873 18.3802 40.9873 18.8208Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M54.1743 20.2188H58.873V24.8305H54.1743V20.2188Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M59.6172 17.5625V24.8296H63.7404V23.3392C64.4927 24.5196 65.6293 25.1097 67.1493 25.1097C68.7155 25.1097 69.9519 24.5431 70.8574 23.409C71.7637 22.2758 72.2169 20.7464 72.2169 18.8208C72.2169 18.3793 72.1897 17.9623 72.1426 17.5625H67.8418C67.917 17.9007 67.956 18.2878 67.956 18.7274C67.956 20.7464 67.2644 21.7554 65.8831 21.7554C64.5008 21.7554 63.8092 20.7772 63.8092 18.8208C63.8092 18.3422 63.851 17.9242 63.9334 17.5625H59.6172Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M73.2646 17.5625H77.5029V24.8296H73.2646V17.5625Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M78.9941 17.5625V20.5905C78.9941 22.0346 79.3703 23.1488 80.1226 23.933C80.8749 24.7172 81.8656 25.1097 83.0937 25.1097C84.6147 25.1097 85.851 24.4887 86.8027 23.2458V24.8296H90.9485V17.5625H86.7111V19.4727C86.7111 20.1091 86.5344 20.6022 86.1809 20.9513C85.8274 21.3012 85.3824 21.4753 84.8449 21.4753C83.7699 21.4753 83.2324 20.8778 83.2324 19.6821V17.5625H78.9941Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M91.6621 18.8208C91.6621 20.7147 92.2531 22.2368 93.4359 23.3854C94.6179 24.535 96.1614 25.1097 98.0658 25.1097C99.555 25.1097 100.86 24.7525 101.981 24.0373C103.087 23.3238 103.801 22.322 104.123 21.0329H100.161C99.7471 21.7318 99.0483 22.0809 98.0658 22.0809C96.7606 22.0809 95.9693 21.4055 95.6928 20.0547H104.4V19.2859C104.4 18.6712 104.344 18.1001 104.246 17.5625H91.7591C91.6965 17.9623 91.6621 18.3802 91.6621 18.8208Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M2.98047 26.041L4.20665 30.5889L9.3671 30.5882L10.3153 26.0406L2.98047 26.041Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M20.1211 26.041H12.7875L13.7356 30.5893H18.8956L20.1211 26.041Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M23.3349 26.041H27.5732V30.5893H23.3349V26.041Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M36.0807 27.0999C36.0807 27.7427 35.5196 28.0645 34.3993 28.0645C33.7395 28.0645 33.2591 27.9494 32.96 27.7182C32.66 27.487 32.4796 27.0836 32.4189 26.5061H28.3184C28.4262 28.089 28.9519 29.2267 29.8964 29.9193C30.8399 30.612 32.311 30.9583 34.3069 30.9583C36.2112 30.9583 37.685 30.5911 38.7301 29.8577C39.7742 29.1243 40.2963 28.0808 40.2963 26.7291C40.2963 26.488 40.2782 26.2604 40.2492 26.041H34.7972C35.2015 26.1362 35.5006 26.245 35.6891 26.3701C35.9502 26.5433 36.0807 26.7862 36.0807 27.0999Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M42.6369 29.1605C43.8189 30.2974 45.3615 30.8658 47.2668 30.8658C48.756 30.8658 50.0612 30.5131 51.1824 29.806C52.2873 29.0998 53.0015 28.1089 53.3242 26.8343H49.3624C48.9481 27.5251 48.2493 27.8705 47.2668 27.8705C46.0214 27.8705 45.2501 27.2558 44.941 26.041H40.9873C41.2157 27.2812 41.7641 28.3229 42.6369 29.1605Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M54.1743 26.041H58.873V30.5893H54.1743V26.041Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M59.6172 30.5893H63.7404V29.1143C64.4927 30.282 65.6293 30.8658 67.1493 30.8658C68.7155 30.8658 69.9519 30.3046 70.8574 29.1841C71.5299 28.3519 71.9514 27.3039 72.1254 26.041H67.7783C67.4928 27.0437 66.862 27.5477 65.8831 27.5477C64.8879 27.5477 64.2534 27.0437 63.9742 26.041H59.6172V30.5893Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M73.2646 26.041H77.5029V30.5893H73.2646V26.041Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M78.9941 26.3964C78.9941 27.8242 79.3703 28.9266 80.1226 29.7027C80.8749 30.4778 81.8656 30.8658 83.0937 30.8658C84.6147 30.8658 85.851 30.2511 86.8027 29.0227V30.5893H90.9485V26.041H86.6006C86.5127 26.3211 86.3767 26.5614 86.1809 26.7536C85.8274 27.099 85.3824 27.2721 84.8449 27.2721C83.9521 27.2721 83.4355 26.8578 83.2841 26.041H78.9941V26.3964Z"
			fill="hsl(var(--blue-500))"
		/>
		<Path d="M93.3117 29.1605C94.4937 30.2974 96.0373 30.8658 97.9416 30.8658C99.4308 30.8658 100.736 30.5131 101.857 29.806C102.963 29.0998 103.677 28.1089 103.999 26.8343H100.037C99.6229 27.5251 98.9241 27.8705 97.9416 27.8705C96.6962 27.8705 95.9258 27.2558 95.6167 26.041H91.6621C91.8905 27.2812 92.4389 28.3229 93.3117 29.1605Z"
			fill="hsl(var(--blue-500))"
		/>
	</Svg>);
}

interface IProps {
	email?: string
	recoveryCodes?: string[]
}

// Create styles
const styles = StyleSheet.create({
	page: {
		flexDirection:   'column',
		backgroundColor: 'white',
		padding:         64,
		fontFamily:      'Inter',
		color:           VARIABLES.COLORS.GRAY[800],
		justifyContent:  'space-between',
	},
	h1: {
		fontSize:     16,
		fontWeight:   600,
		marginTop:    48,
		marginBottom: 12,
	},
	h2: {
		fontSize:     12,
		fontWeight:   600,
		marginBottom: 12,
	},
	p: {
		fontSize:     12,
		marginBottom: 77,
	},
	box: {
		paddingTop:      13,
		paddingBottom:   13,
		paddingLeft:     13,
		paddingRight:    13,
		backgroundColor: VARIABLES.COLORS.GRAY[100],
		borderRadius:    12,
		width:           '31%',
		height:          48,
	},
	wrapper: {
		flexWrap:      'wrap',
		flexDirection: 'row',
		gap:           16,
	},
	spacer: {
		width:  16,
		height: 77,
	},
	codeText: {
		fontSize:   18,
		fontWeight: 500,
	},
	instructionsText: {
		fontSize: 9,
	},
});

Font.register({
	family: 'Inter',
	fonts:  [
		{
			src: Inter400, fontWeight: 400,
		},
		{
			src: Inter500, fontWeight: 500,
		},
		{
			src: Inter600, fontWeight: 600,
		},
	],
});

// Create Document Component
export const MyDocument = ({
	email = 'email@domain.com', recoveryCodes = [],
}: IProps) => (
	<Document>
		<Page size="A4"
			style={styles.page}
		>
			<View>
				<WbLogoSvg />
				<Text style={styles.h1}>2-step authentication recovery codes</Text>
				<Text style={styles.h2}>{email}</Text>
				<Text style={styles.p}>If you ever lose access to your Google Authenticator, you can use the following recovery codes to log-in. Please save them in a secure location.</Text>
				<View style={styles.wrapper}>
					{recoveryCodes.map((code) => (<View style={styles.box}><Text style={styles.codeText}>{code}</Text></View>))}
				</View>
			</View>
			<Text style={styles.instructionsText}>Issued by Httpool Latvia SIA, Maldugunu iela 4, LV-2167, Marupe, Latvia ・ support@wise.blue</Text>
		</Page>
	</Document>
);
